import { c as _c } from "react/compiler-runtime";
import DeleteConfirmationModal from "../delete-confirmation-modal";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSubMenu, DropdownMenuSubMenuContent, DropdownMenuSubMenuTrigger, DropdownMenuTrigger, DropdownSettingsButton } from "../ui/dropdown";
import { useState } from "react";
import { RiCheckLine } from "react-icons/ri";
import { DuplicateDose } from "@/components/dose/add-dose";
import { DOSE_STATUS_CONFIG } from "@/components/dose/dose-status-badge";
import EditDose from "@/components/dose/edit-dose";
import { canPrintPrescriptionForTenant } from "@/components/dose/prescription-availability";
import PrintLabel from "@/components/dose/print-label";
import PrintPrescription from "@/components/dose/print-prescription";
import SignOffDoseModal from "@/components/dose/sign-off-dose-modal";
import { queryClient } from "@/config/react-query";
import { useTenant } from "@/contexts/tenant-provider";
import { useUser } from "@/contexts/user-provider";
import { useLaunchDoseSpot } from "@/hooks/use-launch-dosespot";
import { useModule } from "@/hooks/use-module";
import { PERMISSIONS, hasPermission } from "@/lib/permissions";
import { cx } from "@/lib/tailwind-utils";
import { DoseManagementStatus, MedicationSummary } from "@/types/medication";
import { NoteDetail, NoteListItem } from "@/types/notes";
import { PatientDetail } from "@/types/patient";
import { noteQueryKeys } from "@/api/provider/scribe/note-query";
import { useDeleteMedicationMutation, useSignOffMedicationMutation, useUpdateDoseManagementStatusMutation } from "@/api/provider/user/patient/patient-mutation";
export const DoseDropdown = t0 => {
  const $ = _c(85);
  const {
    patient,
    selectedNote,
    medication
  } = t0;
  const deleteMedicationMutation = useDeleteMedicationMutation();
  const {
    currentUser
  } = useUser();
  const signOffMedicationMutation = useSignOffMedicationMutation();
  const updateDoseManagementStatusMutation = useUpdateDoseManagementStatusMutation();
  const [pendingMedication, setPendingMedication] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [editDoseOpen, setEditDoseOpen] = useState(false);
  const {
    tenant
  } = useTenant();
  const hasDoseSpotModule = useModule("DOSESPOT");
  const hasLabelPrinting = useModule("LABEL_PRINTING");
  let t1;
  if ($[0] !== currentUser) {
    t1 = hasPermission(currentUser, PERMISSIONS.PATIENTS_DOSES_EDIT);
    $[0] = currentUser;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const canEditDose = t1;
  let t2;
  if ($[2] !== currentUser) {
    t2 = hasPermission(currentUser, PERMISSIONS.PATIENTS_DOSES_PRINT);
    $[2] = currentUser;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const canPrintDoseLabel = t2;
  let t3;
  if ($[4] !== currentUser) {
    t3 = hasPermission(currentUser, PERMISSIONS.PATIENTS_DOSES_DELETE);
    $[4] = currentUser;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const canDeleteDose = t3;
  const t4 = currentUser?.dosespotUserId;
  let t5;
  if ($[6] !== patient || $[7] !== t4) {
    t5 = {
      patient,
      userId: t4,
      openInNewTab: true
    };
    $[6] = patient;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    launchDoseSpot
  } = useLaunchDoseSpot(t5);
  let t6;
  if ($[9] !== selectedNote) {
    t6 = () => {
      if (selectedNote?.id) {
        queryClient.invalidateQueries({
          queryKey: noteQueryKeys.list({
            noteId: selectedNote.id
          })
        });
      }
    };
    $[9] = selectedNote;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleMedicationAdd = t6;
  let t7;
  if ($[11] !== deleteMedicationMutation || $[12] !== selectedNote) {
    t7 = async medicationId => {
      if (selectedNote?.id) {
        queryClient.invalidateQueries({
          queryKey: noteQueryKeys.list({
            noteId: selectedNote.id
          })
        });
      }
      await deleteMedicationMutation.mutateAsync({
        medicationId
      });
    };
    $[11] = deleteMedicationMutation;
    $[12] = selectedNote;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const handleMedicationDelete = t7;
  let t8;
  if ($[14] !== medication.id || $[15] !== medication.managementStatus || $[16] !== updateDoseManagementStatusMutation) {
    t8 = managementStatus => {
      if (medication.managementStatus === managementStatus) {
        return;
      }
      updateDoseManagementStatusMutation.mutate({
        doseId: medication.id,
        managementStatus
      });
    };
    $[14] = medication.id;
    $[15] = medication.managementStatus;
    $[16] = updateDoseManagementStatusMutation;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const handleManagementStatusUpdate = t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <DropdownMenuTrigger asChild={true}><DropdownSettingsButton aria-label="Dose actions" /></DropdownMenuTrigger>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== canEditDose || $[20] !== medication.dosespotMedicationId) {
    t10 = !medication.dosespotMedicationId && canEditDose && <DropdownMenuItem onSelect={e => {
      e.preventDefault();
      setMenuOpen(false);
      setEditDoseOpen(true);
    }}>Edit Dose</DropdownMenuItem>;
    $[19] = canEditDose;
    $[20] = medication.dosespotMedicationId;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== canEditDose || $[23] !== handleManagementStatusUpdate || $[24] !== medication.managementStatus) {
    t11 = canEditDose && <DropdownMenuSubMenu><DropdownMenuSubMenuTrigger>Update Status</DropdownMenuSubMenuTrigger><DropdownMenuSubMenuContent className="ml-2 w-48">{Object.values(DoseManagementStatus).map(status => {
          const config = DOSE_STATUS_CONFIG[status];
          const Icon = config.icon;
          const isSelected = medication.managementStatus === status;
          return <DropdownMenuItem key={status} onSelect={() => handleManagementStatusUpdate(status)} className="flex items-center justify-between"><span className="flex items-center gap-2"><Icon className={cx("size-4", config.color)} />{config.label}</span>{isSelected && <RiCheckLine className="ml-2 size-4 text-foreground" />}</DropdownMenuItem>;
        })}</DropdownMenuSubMenuContent></DropdownMenuSubMenu>;
    $[22] = canEditDose;
    $[23] = handleManagementStatusUpdate;
    $[24] = medication.managementStatus;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== handleMedicationAdd || $[27] !== medication || $[28] !== patient || $[29] !== selectedNote) {
    t12 = !medication.dosespotMedicationId && <DuplicateDose patientId={patient.id} selectedNote={selectedNote} sourceDose={medication} onSubmit={handleMedicationAdd}><DropdownMenuItem onSelect={_temp}>Duplicate Dose</DropdownMenuItem></DuplicateDose>;
    $[26] = handleMedicationAdd;
    $[27] = medication;
    $[28] = patient;
    $[29] = selectedNote;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== currentUser || $[32] !== medication) {
    t13 = !medication.dosespotMedicationId && hasPermission(currentUser, PERMISSIONS.SIGN_OFF_MEDICATIONS) && !medication.signedOffDate && <DropdownMenuItem onSelect={e_1 => {
      e_1.preventDefault();
      setPendingMedication(medication);
    }}>Sign off dose</DropdownMenuItem>;
    $[31] = currentUser;
    $[32] = medication;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== hasDoseSpotModule || $[35] !== launchDoseSpot || $[36] !== medication.dosespotMedicationId || $[37] !== patient) {
    t14 = hasDoseSpotModule && medication.dosespotMedicationId && <DropdownMenuItem onSelect={e_2 => {
      e_2.preventDefault();
      launchDoseSpot(patient.id);
    }} className="cursor-pointer">Open in E-prescribing</DropdownMenuItem>;
    $[34] = hasDoseSpotModule;
    $[35] = launchDoseSpot;
    $[36] = medication.dosespotMedicationId;
    $[37] = patient;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== medication || $[40] !== patient || $[41] !== tenant?.subDomain) {
    t15 = canPrintPrescriptionForTenant(tenant?.subDomain) && <PrintPrescription medication={medication} patient={patient}><DropdownMenuItem onSelect={_temp2}>Print Prescription</DropdownMenuItem></PrintPrescription>;
    $[39] = medication;
    $[40] = patient;
    $[41] = tenant?.subDomain;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== canPrintDoseLabel || $[44] !== hasLabelPrinting || $[45] !== medication || $[46] !== patient) {
    t16 = hasLabelPrinting && canPrintDoseLabel && <PrintLabel medication={medication} patient={patient}><DropdownMenuItem onSelect={_temp3}>Print Label</DropdownMenuItem></PrintLabel>;
    $[43] = canPrintDoseLabel;
    $[44] = hasLabelPrinting;
    $[45] = medication;
    $[46] = patient;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== canDeleteDose || $[49] !== handleMedicationDelete || $[50] !== medication.dosespotMedicationId || $[51] !== medication.id) {
    t17 = !medication.dosespotMedicationId && canDeleteDose && <DeleteConfirmationModal onConfirm={() => handleMedicationDelete(medication.id)} title="Delete Dose Event" subtitle="Are you sure you want to delete this dose event? This action cannot be undone."><DropdownMenuItem onSelect={_temp4} className="text-red-500">Delete Dose</DropdownMenuItem></DeleteConfirmationModal>;
    $[48] = canDeleteDose;
    $[49] = handleMedicationDelete;
    $[50] = medication.dosespotMedicationId;
    $[51] = medication.id;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== t10 || $[54] !== t11 || $[55] !== t12 || $[56] !== t13 || $[57] !== t14 || $[58] !== t15 || $[59] !== t16 || $[60] !== t17) {
    t18 = <DropdownMenuContent align="end">{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}</DropdownMenuContent>;
    $[53] = t10;
    $[54] = t11;
    $[55] = t12;
    $[56] = t13;
    $[57] = t14;
    $[58] = t15;
    $[59] = t16;
    $[60] = t17;
    $[61] = t18;
  } else {
    t18 = $[61];
  }
  let t19;
  if ($[62] !== menuOpen || $[63] !== t18) {
    t19 = <DropdownMenu modal={false} open={menuOpen} onOpenChange={setMenuOpen}>{t9}{t18}</DropdownMenu>;
    $[62] = menuOpen;
    $[63] = t18;
    $[64] = t19;
  } else {
    t19 = $[64];
  }
  let t20;
  if ($[65] !== canEditDose || $[66] !== editDoseOpen || $[67] !== medication) {
    t20 = !medication.dosespotMedicationId && canEditDose && editDoseOpen && <EditDose medication={medication} open={editDoseOpen} onOpenChange={setEditDoseOpen} />;
    $[65] = canEditDose;
    $[66] = editDoseOpen;
    $[67] = medication;
    $[68] = t20;
  } else {
    t20 = $[68];
  }
  const t21 = !!pendingMedication;
  let t22;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = () => {
      setPendingMedication(null);
    };
    $[69] = t22;
  } else {
    t22 = $[69];
  }
  let t23;
  if ($[70] !== currentUser?.id || $[71] !== patient || $[72] !== pendingMedication || $[73] !== signOffMedicationMutation) {
    t23 = async () => {
      if (!pendingMedication) {
        return;
      }
      await signOffMedicationMutation.mutateAsync({
        medicationId: pendingMedication.id,
        patientId: patient.id,
        currentProviderId: currentUser?.id
      });
      setPendingMedication(null);
    };
    $[70] = currentUser?.id;
    $[71] = patient;
    $[72] = pendingMedication;
    $[73] = signOffMedicationMutation;
    $[74] = t23;
  } else {
    t23 = $[74];
  }
  let t24;
  if ($[75] !== patient || $[76] !== pendingMedication || $[77] !== signOffMedicationMutation.isPending || $[78] !== t21 || $[79] !== t23) {
    t24 = <SignOffDoseModal isOpen={t21} onClose={t22} onConfirm={t23} medication={pendingMedication} patient={patient} isLoading={signOffMedicationMutation.isPending} />;
    $[75] = patient;
    $[76] = pendingMedication;
    $[77] = signOffMedicationMutation.isPending;
    $[78] = t21;
    $[79] = t23;
    $[80] = t24;
  } else {
    t24 = $[80];
  }
  let t25;
  if ($[81] !== t19 || $[82] !== t20 || $[83] !== t24) {
    t25 = <>{t19}{t20}{t24}</>;
    $[81] = t19;
    $[82] = t20;
    $[83] = t24;
    $[84] = t25;
  } else {
    t25 = $[84];
  }
  return t25;
};
function _temp(e_0) {
  return e_0.preventDefault();
}
function _temp2(e_3) {
  return e_3.preventDefault();
}
function _temp3(e_4) {
  return e_4.preventDefault();
}
function _temp4(e_5) {
  return e_5.preventDefault();
}